export const getFilterType = (filterConfig) => {
  const { filterType, tagType } = filterConfig.source || {};

  switch (filterType) {
    case "annoHierarchyType":
      return { filterType: "annoHierarchyType" };
    case "tagType": {
      /**
       * All tagType filters should now be treated as contentTagType.
       * The old 'tagType' config has been deprecated - it was only used for user profile tags,
       */
      return { filterType: "contentTagType" };
    }
    case "profileTagType":
      return { filterType: "usersType" };
    default:
      return { filterType };
  }
};